'use client';

import React, { useMemo } from 'react';
import { Box, Button, Stack, Card, DialogContent } from '@castlery/fortress';
import { Replay } from '@castlery/fortress/Icons';
import { selectOrder } from '@castlery/modules-order-domain';
import {
  OrderSummary,
  CustomerHeader,
  PosAddService,
  CouponWallet,
  PushToOnline,
  PosCartItems,
  PosCartItemsV2,
  OrderSummaryV2,
  CouponWalletV2,
} from '@castlery/modules-order-components';
import { useAppDispatch, useAppSelector } from '@castlery/shared-redux-store';
import { refreshCartCommand } from '@castlery/modules-order-services';
import { useAsyncFn } from 'react-use';
import {
  PosTradePartner,
  PayButton,
  PosCheckoutButton,
  PosCheckoutButtonV2,
} from '@castlery/modules-checkout-components';
import { usePathname } from 'next/navigation';
import { accessInSG, enableO2O, enabledNewPromotion } from '@castlery/config';

export const PosCart = () => {
  const inCheckout = usePathname().includes('/checkout');

  const dispatch = useAppDispatch();
  const order = useAppSelector(selectOrder);
  const needRefresh = useMemo(() => order?.line_items?.some((item) => item.is_price_outdated), [order]);

  const [loadingState, refreshHandler] = useAsyncFn(async () => {
    return await dispatch(refreshCartCommand());
  }, [dispatch]);

  const showTradePartner = inCheckout && accessInSG;
  return (
    <React.Fragment>
      <DialogContent sx={{ padding: 0 }}>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
          }}
        >
          <Stack sx={{ flex: 'none' }}>
            <CustomerHeader />
            {showTradePartner && <PosTradePartner />}
          </Stack>
          {needRefresh && (
            <Stack sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
              <Button
                variant="tertiary"
                loading={loadingState.loading}
                startDecorator={<Replay color="neutral" />}
                sx={{ width: 100, p: 0, minHeight: 'auto' }}
                onClick={refreshHandler}
              >
                Refresh
              </Button>
            </Stack>
          )}
          <Card sx={{ flex: 1, overflowY: 'auto', p: 0, minHeight: 200 }}>
            {enabledNewPromotion ? <PosCartItemsV2 /> : <PosCartItems />}
          </Card>
          {!inCheckout && (
            <Stack sx={{ flex: 'none' }}>
              <PosAddService />
            </Stack>
          )}
          <Stack sx={{ flex: 'none' }}>
            {enabledNewPromotion ? (
              <OrderSummaryV2 inCheckout={inCheckout} CouponWallet={<CouponWalletV2 />} />
            ) : (
              <OrderSummary inCheckout={inCheckout} CouponWallet={<CouponWallet />} />
            )}
          </Stack>
        </Box>
      </DialogContent>
      <Stack spacing={2} sx={{ flex: 'none' }}>
        {inCheckout ? (
          <PayButton />
        ) : (
          <>
            {enabledNewPromotion ? <PosCheckoutButtonV2 /> : <PosCheckoutButton />}
            {enableO2O && <PushToOnline />}
          </>
        )}
      </Stack>
    </React.Fragment>
  );
};
